import React, { Component } from "react";
import Select from "react-select";
import { Field, reduxForm, formValueSelector, change } from 'redux-form'
import moment from 'moment';

import { connect } from 'react-redux';
import { InputField } from '../../inputField';

import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { StartOfThisMonthDatePicker, DatePicker } from '../../datePicker';
import { Selection, DisabledSelection, SelectionWithProps } from '../../selection';

const changeDeliveryTime = (data, success, sales_order_id) => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/sales_order/${sales_order_id}/dispatch_date`,
    data,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
    .then(res => {
      success();
    }, err => {
      console.log(err);
      // alert(err.statusText);
    })
}

// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222
const fetchAvaliablePickupTime = (date, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/mobile/pickup_time?pickup_date=${date}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
    .then(res => {
      console.log('res', res);
      success(res.data);
    }, err => {
      console.log(err);
      // alert(err.statusText);
    })
}


const modalStyle = {
  width: '300px',
  height: '270px',
  marginLeft: '-5%',
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

class form extends Component {
  state = {
    DispatchDateOptions: [],
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.date !== this.props.date && this.props.date) {
      this.props.setFormValue('DispatchDate', null);
      this.setState({
        DispatchDateOptions: [],
      });
      const pickupDate = moment(this.props.date).format('YYYY-MM-DD');
      fetchAvaliablePickupTime(pickupDate, (pickupTimes) => {
        this.setState({
          DispatchDateOptions: pickupTimes.map(time => ({
            label: time.name,
            value: time.value,
          })),
        })
      })
    }
  }

  handleFormSubmit = formProps => {
    if (!formProps.DispatchDate) return;
    const success = () => {
      this.props.onSuccess();
    }
    changeDeliveryTime({
      DispatchDate: formProps.DispatchDate.value,
    }, success, this.props.selectedRows[0].SalesOrder_id)
  }

  render() {
    const {
      handleSubmit
    } = this.props;
    return (
      <form style={{ width: '100%', padding: '10px' }}>
        <div className="form-group" style={{ marginTop: '10px' }}>
          <div className="col-xs-12">
            <Translate value="pickup_date" />:
          </div>
          <div className="col-xs-12">
            <Field name="date" component={DatePicker} selected={this.props.date}/>
          </div>
        </div>
        <div className="form-group" style={{ marginTop: '40px' }}>
          <div className="col-xs-12">
            <Translate value="pickup_time" />:
          </div>
          <div className="col-xs-12">
            <Field name="DispatchDate" component={Selection} options={this.state.DispatchDateOptions} />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', marginTop: '130px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={this.props.setModalVisibility}
          >
            <Translate value="cancel" />
          </Button>
          <span style={{ width: '50px' }} />
          <Button
            bsStyle="success"
            className="print-btn"
            type="button"
            onClick={handleSubmit(this.handleFormSubmit)}
          >
            <Translate value="confirm" />
          </Button>
        </div>
      </form>
    )
  }
}

const formName = 'PickupTimeChangeForm';

const selector = formValueSelector(formName);

const DeliveryTimeChangeForm = reduxForm({
  // a unique name for the form
  form: formName,
  enableReinitialize: true,
})(form);


const PickupTimeChange = ({ setModalVisibility, isVisible, estDeliveryEditingSOID, selectedRows, onSuccess, date, setFormValue }) => (
  <SkyLightStateless
    title={'Pickup Time'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <DeliveryTimeChangeForm
      setModalVisibility={setModalVisibility}
      estDeliveryEditingSOID={estDeliveryEditingSOID}
      selectedRows={selectedRows}
      onSuccess={onSuccess}
      date={date}
      setFormValue={setFormValue}
    />
  </SkyLightStateless>
)

PickupTimeChange.propTypes = propTypes;
PickupTimeChange.defaultProps = defaultProps;

const mapState = (state) => {
  return ({
    date: selector(state, 'date'),
  })
}
const mapProps = dispatch => ({
  setFormValue: (field, value) => {
    dispatch(change(formName, field, value));
  }
})
export default connect(mapState, mapProps)(PickupTimeChange);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx